"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    width: 19,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), __jsx("defs", null, __jsx("filter", {
    x: "-2.1%",
    y: "-2.8%",
    width: "104.3%",
    height: "106.9%",
    filterUnits: "objectBoundingBox",
    id: "prefix__a"
  }, __jsx("feOffset", {
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), __jsx("feGaussianBlur", {
    stdDeviation: 12,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), __jsx("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), __jsx("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
    in: "shadowBlurOuter1"
  })), __jsx("rect", {
    id: "prefix__b",
    x: 24,
    y: 24,
    width: 1872,
    height: 1152,
    rx: 8
  })), __jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, __jsx("g", {
    transform: "translate(-442 -309)"
  }, __jsx("use", {
    fill: "currentColor",
    filter: "url(#prefix__a)",
    xlinkHref: "#prefix__b"
  }), __jsx("rect", {
    stroke: "#EBEBEB",
    strokeLinejoin: "square",
    fill: "#FFF",
    x: 24.5,
    y: 24.5,
    width: 1871,
    height: 1151,
    rx: 8
  })), __jsx("g", {
    transform: "translate(-14 -16)"
  }, __jsx("rect", {
    stroke: "#EBEBEB",
    fill: "#FFF",
    x: 0.5,
    y: 0.5,
    width: 383,
    height: 47,
    rx: 4
  }), __jsx("g", {
    transform: "translate(15 17)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, __jsx("circle", {
    cx: 5.526,
    cy: 3.592,
    r: 3.039
  }), __jsx("path", {
    d: "M.553 12.71a4.974 4.974 0 119.947 0"
  }), __jsx("circle", {
    cx: 13.062,
    cy: 5.25,
    r: 2.487
  }), __jsx("path", {
    d: "M11.652 8.892a4.072 4.072 0 015.48 3.819"
  })))));
}
var _default = exports.default = SvgComponent;